import * as React from 'react';
import * as _ from 'underscore';

import { TextLinkWidget } from '@tableau/widgets';

import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { INamedItemInfo } from '~src/ts/models/resourceInfoParts';

import { ContentDetailSection, DetailEditButton } from './ContentDetailSection';


export interface ProjectDetailSectionProps {
  readonly project: INamedItemInfo;
  readonly isActionEnabled: boolean;
  readonly moveToProject: () => Promise<IResult>;
  readonly urls: SpacesSiteUrls;
  readonly incrementRouterSpaceReactKey: () => void;
}

export function ProjectDetailSection(props: ProjectDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.column_project()}
      testId={'project'}
      detail={!_.isEmpty(props.project) ?
        <TextLinkWidget
          testId='project-name'
          href={props.urls.projectUrl(props.project.id)}
          children={props.project.name}
        /> : ''}
      isActionAllowed={props.isActionEnabled}
      action={
        <DetailEditButton
          buttonLabel={Messages.move_action()}
          buttonTestId={'move-to-project'}
          onClickAction={() => {
            props.moveToProject()
              .then(props.incrementRouterSpaceReactKey);
          }}
        />
      }
    />
  );
}
